// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3Jmki","error":"Textarea_error__16Tsb","readonly":"Textarea_readonly__2KST6","disabled":"Textarea_disabled__3lMqC"};